import React, { useState } from 'react';
import BaseModel from '../../BaseModal';
import { FlexWrapperCenter } from '../../styles/WrapperStyles';
import { InputText } from '../../styles/TextStyles';
import { BaseButton } from '../../styles/ButtonStyles';
import styled from 'styled-components';

const BarImage = styled.img`
    width: 220px;
    height: 220px;
`;

const ParentDiv = styled.div`
    width: 250px;
`;

const CodeText = styled(InputText)`
    width: 220px;
    height: 60px;
    margin-top: 20px;
`;

const LoginButton = styled(BaseButton)`
    margin-top: 20px;
`;

const BarCode = ({ closeModal, passCodeClicked, url }) => {
    const [code, setCode] = useState('');

    const passCodeChange = (event) => {
        setCode(event.target.value);
    };

    const handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            passCodeClicked(code);
        }
    };

    return (
        <BaseModel closeModal={closeModal}>
            <ParentDiv>
                <FlexWrapperCenter>
                    <BarImage src={url} />
                </FlexWrapperCenter>
                <FlexWrapperCenter>
                    <CodeText
                        type="text"
                        value={code}
                        onChange={(e) => passCodeChange(e)}
                        onKeyPress={(e) => handleKeyPress(e)}
                    />
                </FlexWrapperCenter>
                <FlexWrapperCenter>
                    <LoginButton onClick={() => passCodeClicked(code)}>Login</LoginButton>
                </FlexWrapperCenter>
            </ParentDiv>
        </BaseModel>
    );
};

export default BarCode;
